import * as React from "react";
const SvgFiRrCitrus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-citrus_svg__a)">
      <path
        fill="#062147"
        d="M15 16.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 15 16.5M13.5 11a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 13.5 11m6.5 1.5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 20 12.5M9.283 1.671A1.004 1.004 0 0 1 9.305.259a1 1 0 0 1 1.406.012c.054.054.796.851 1.422 2.323.192-.295.414-.58.675-.841C13.987.575 15.602.158 16.749.016a1.99 1.99 0 0 1 1.664.572c.44.44.648 1.047.572 1.664-.142 1.147-.559 2.761-1.737 3.94-1.668 1.668-4.229 1.809-5.044 1.809-1.203 0-1.203-.993-1.203-1 0-3.496-1.646-5.255-1.717-5.329zm3.771 4.274c.829-.101 1.995-.385 2.778-1.168.777-.777 1.063-1.937 1.167-2.772v-.003c-.841.102-2 .389-2.777 1.166-.782.782-1.067 1.948-1.168 2.777m8.626-1.037a.999.999 0 1 0-1.612 1.184A9.92 9.92 0 0 1 21.999 12c0 5.514-4.486 10-10 10S2 17.514 2 12a10.04 10.04 0 0 1 5-8.663 1 1 0 0 0 .365-1.366 1 1 0 0 0-1.366-.365A12.05 12.05 0 0 0 0 12c0 6.617 5.383 12 12 12s12-5.383 12-12a11.9 11.9 0 0 0-2.32-7.092"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-citrus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCitrus;
